import { actions } from "../../actions/documents/documents";

export default function documents( state = {}, action ) {

    const newState = { ...state };

    switch( action.type ) {
        case actions.SET_DOCUMENTS: return setDocuments( newState, action );
        default: return state;
    }
}

function setDocuments( newState, action ) {
    newState.documents = action.documents;
    newState.pagination = action.pagination;
    newState.options = action.options;

    return newState;
}




// WEBPACK FOOTER //
// src/client/reducers/documents/documents.js